import React from 'react';
import { PersistGate as ReduxPersistGate } from 'redux-persist/integration/react';
import type { Persistor } from 'redux-persist';

interface PersistGateCompatProps {
  persistor: Persistor;
  loading?: React.ReactNode;
  children?: React.ReactNode | ((bootstrapped: boolean) => React.ReactNode);
  onBeforeLift?: () => void | Promise<void>;
}

const PersistGateComponent =
  ReduxPersistGate as unknown as React.ComponentType<PersistGateCompatProps>;

export default function PersistGateCompat(props: PersistGateCompatProps) {
  return <PersistGateComponent {...props} />;
}
